/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateSequenceMutationRequest,
  CreateSequenceMutationResponse,
  CreateSequence400,
} from '../types/CreateSequence'

function getCreateSequenceUrl() {
  const res = { method: 'POST', url: `/api/v1/emailbison/sequences/` as const }
  return res
}

/**
 * @description Create a new sequence.
 * Request body:
 * title: string - Sequence title
 * campaign_id: int - ID of the campaign
 * steps: array - List of step objects
 * @summary Create a sequence
 * {@link /api/v1/emailbison/sequences/}
 */
export async function createSequence(
  data: CreateSequenceMutationRequest,
  config: Partial<RequestConfig<CreateSequenceMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateSequenceMutationResponse,
    ResponseErrorConfig<CreateSequence400>,
    CreateSequenceMutationRequest
  >({
    method: 'POST',
    url: getCreateSequenceUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
